var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Ppt'),_vm._v(" "),_c('Divider'),_vm._v(" "),_c('Intro'),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"height":"100px","width":"100%"},attrs:{"src":require("../assets/33.png"),"alt":""}}),_vm._v(" "),_c('Divider2'),_vm._v(" "),_c('News'),_vm._v(" "),_c('Divider1'),_vm._v(" "),_c('Trend')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37f25bcf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main.vue
// module id = null
// module chunks = 